
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import DateSelector from '@/components/generic/DateSelector.vue'
import { TemplateQuestionsTypes } from '@/types/Fillgrid'

@Component({
  components: {
    DateSelector
  }
})
export default class InputFormValue extends Vue {
  @Prop()
  field: any

  @Prop()
  index: number

  QUESTION_TYPES = TemplateQuestionsTypes

  feedback = ''

  regex = {
    email: /^[_A-Za-z0-9-]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
    phone: /^[0-9]{7,15}$/,
    integer: /^-?[0-9]+$/,
    decimal: /^-?[0-9]+(\.[0-9]+)?$/
  }

  location = {
    lat: '',
    lng: '',
    alt: ''
  }

  created () {
    switch (this.field.type) {
      case TemplateQuestionsTypes.TEXT:
        this.field.error = 'Ingresa el texto'
        break
      case TemplateQuestionsTypes.EMAIL:
        this.field.error = 'Ingresa un correo válido (correo@dominio.com)'
        break
      case TemplateQuestionsTypes.PHONE:
        this.field.error = 'Ingresa un teléfono válido'
        break
      case TemplateQuestionsTypes.INTEGER:
        this.field.error = 'Ingresa un número entero válido'
        break
      case TemplateQuestionsTypes.DECIMAL:
        this.field.error = 'Ingresa un número decimal válido'
        break
      case TemplateQuestionsTypes.LOCATION:
        this.field.error = 'Ingresa una georeferencia válida'
        break
      default:
        this.field.error = 'Ingrese un valor'
    }
  }

  setLocation (value: string, part: string) {
    switch (part) {
      case 'lat':
        this.location.lat = value
        break
      case 'lng':
        this.location.lng = value
        break
      case 'alt':
        this.location.alt = value
    }
    this.field.value = `${this.location.lat},${this.location.lng},${this.location.alt}`
  }

  @Watch('field.value')
  watchValue (val: any) {
    this.isValidValue()
  }

  isValidValue () {
    if (!this.field.value) {
      this.field.valid = false
      return
    }

    switch (this.field.type) {
      case TemplateQuestionsTypes.TEXT:
        this.field.valid = this.field.value.length > 0
        break
      case TemplateQuestionsTypes.SELECT:
        this.field.valid = this.field.value.length > 0
        break
      case TemplateQuestionsTypes.PHONE:
        this.field.valid = this.regex.phone.test(this.field.value)
        break
      case TemplateQuestionsTypes.EMAIL:
        this.field.valid = this.regex.email.test(this.field.value)
        break
      case TemplateQuestionsTypes.INTEGER:
        this.field.valid = this.regex.integer.test(this.field.value)
        break
      case TemplateQuestionsTypes.DECIMAL:
        this.field.valid = this.regex.decimal.test(this.field.value)
        break
      case TemplateQuestionsTypes.LOCATION:
        const parts = this.field.value.split(',')
        this.field.valid = this.regex.decimal.test(parts[0]) &&
                           this.regex.decimal.test(parts[1]) &&
                           this.regex.decimal.test(parts[2])
        break
      default:
        this.field.valid = true
    }
  }
}
